<template>
  <v-data-table
    density="compact"
    hide-default-footer
    :headers="headers"
    :items="filteredClaims"
    :items-per-page="-1"
    :mobile-breakpoint="960"
  >
    <template #item.date="{item}">
      {{ m(item.date, $t('commonStrings.dateDisplayFormat')) }}
    </template>
    <template #item.claimTypeId="{item}">
      {{ $t(`enums.salaryTypes.${item.claimTypeId}`) }}
    </template>
    <template #item.payingOrgs="{item}">
      <paying-orgs-label :paying-orgs="item.payingOrgs" />
    </template>
    <template #item.salaryCost="{item}">
      <amount-label :value="item.salaryCost" />
    </template>
    <template #item.amount="{item}">
      <amount-label :value="item.amount" />
    </template>
    <template #item.editAction="{ item }">
      <v-btn
        rounded
        class="primary-inverted-button my-2"
        size="small"
        @click="onEdit(item)"
      >
        {{ $t("salaryPanelStrings.labels.editButton") }}
      </v-btn>
    </template>
    <template #item.removeAction="{ item }">
      <v-btn
        rounded
        size="small"
        class="accent-inverted-button my-2"
        @click="onRemove(item)"
      >
        {{ $t("salaryPanelStrings.labels.removeButton") }}
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import AmountLabel from "@/views/common/components/AmountLabel";
import PayingOrgsLabel from "@/views/applications/components/PayingOrgsLabel";
import { mapGetters } from "vuex";
import { useSnacks } from '@/composables/snacks';
import { m } from '@/plugins/moment';

export default {
  name: "SalaryTable",
  components: {
    PayingOrgsLabel,
    AmountLabel
  },
  props: {
    claims: {
      default: () => [],
      type: Array
    },
    editableSalaryClaimPayingOrgs: {
      required: true
    }
  },
  setup() {
    const { addSnackbar } = useSnacks();
    return { addSnackbar, m };
  },
  data: function () {
    return {
      headers: [
        {
          text: this.$t("salaryPanelStrings.tableHeaders.date"),
          value: "date",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("salaryPanelStrings.tableHeaders.salaryType"),
          value: "claimTypeId",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("salaryPanelStrings.tableHeaders.payingOrgs"),
          value: "payingOrgs",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("salaryPanelStrings.tableHeaders.count"),
          value: "salaryCount",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("salaryPanelStrings.tableHeaders.salaryCost"),
          value: "salaryCost",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("salaryPanelStrings.tableHeaders.amount"),
          value: "amount",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("salaryPanelStrings.tableHeaders.comment"),
          value: "comment",
          sortable: false,
          filterable: false
        },
        {
          value: "editAction",
          sortable: false,
          filterable: false
        },
        {
          value: "removeAction",
          sortable: false,
          filterable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      currentApplication: "application/currentApplicationStore/application"
    }),
    filteredClaims() {
      // all claims
      const availableClaims = this.claims.filter(x => !x.isDeleted);
      const readOnlyClaims = availableClaims.filter(x => x.readOnly);
      const editableClaims = availableClaims.filter(x => !x.readOnly);

      // only sort on readonly claims,
      // as otherwise there is a lot of
      // unintentional ui updates/line jumps
      return readOnlyClaims
        .sort((a, b) => m(a.date).diff(b.date))
        .concat(editableClaims);
    },
    claimsWithSalaryFraction() {
      return (
        this.currentApplication.claims.trips?.some(
          x => x.usesSalaryFraction
        ) ||
        this.currentApplication.claims.receipts?.some(
          x => x.usesSalaryFraction
        ) ||
        this.currentApplication.claims.diet?.usesSalaryFraction
      );
    }
  },
  methods: {
    onEdit(claim) {
      const index = this.claims.indexOf(claim);
      this.$emit('edit-clicked', {claim, index} );
    },
    onRemove(claim) {
      if (this.claimsWithSalaryFraction) {
        this.addSnackbar(this.$t("salaryTableStrings.removingSalaryDenial"),
          "error"
        );
        return;
      }

      claim.isDeleted = true;
    }
  }
};
</script>